import { useEffect, useState } from 'react';
import type { ICustomControlRequestAddEditProps } from '../../interfaces/';
import { getServiceLabel } from '../../../../../../common/customControls/getServiceLabel';
import { ToastType } from '../../../../../../common/enums/toastType';
import { getDisplayName } from '../../../../../../common/utils/getDisplayName';
import { translateKey } from '../../../../../translate';
import { useEpisodeContext } from '../../../../../utils/hooks/useEpisodeContext';
import { showServiceToast } from '../../../../../utils/showToast';
import { NewOrEditRequestProcessContainer } from '../../utils/v1/NewOrEditRequestProcessContainer';
import { GgzoAddEditForm } from './GgzoAddEditForm';

export function GgzoIntV1RequestAddEdit(props: ICustomControlRequestAddEditProps) {
    const { patient } = useEpisodeContext();
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [emailKnown, setEmailKnown] = useState(false);

    useEffect(() => {
        if (patient.emailAddress && !props.request.customControlData.emailadres) {
            setEmailKnown(true);
            props.handleChangeCustomControl({ emailadres: patient.emailAddress });
        }
    }, []);

    return (
        <NewOrEditRequestProcessContainer
            isExaminationRequest
            isFirstItem={props.isFirstItem}
            itemState={props.itemState}
            process={props.process}
            service={props.service}
            title={getServiceLabel(props.service.code, 'request', props.service.name)}
            tooltip="De 'DIPP' oftewel Digitale Indicatiehulp Psychische Problemen is een digitale beslisondersteuner met ca. 63 vragen uit gevalideerde vragenlijsten zoals de 4DKL en de Gewaarwordingenlijst."
            tooltipHeader="Informatie over Ksyos Onderzoek"
        >
            <GgzoAddEditForm
                {...props}
                buttonDisabled={buttonDisabled}
                emailKnown={emailKnown}
                saveRequest={saveRequest}
            />
        </NewOrEditRequestProcessContainer>
    );

    async function saveRequest(saveType: 'draft' | 'final') {
        setButtonDisabled(true);

        const validatedRequest = await props.validateRequest(saveType);
        if (!validatedRequest) {
            setButtonDisabled(false);

            return;
        }

        const requestId = await props.onSaveRequest(saveType);

        if (saveType === 'final') {
            showServiceToast(
                ToastType.success,
                undefined,
                props.service,
                'request',
                `Het onderzoek is verstuurd naar ${getDisplayName(patient)}`
            );
        } else {
            showServiceToast(
                ToastType.success,
                'toast.draftSuccess',
                props.service,
                'request',
                translateKey('toast.draftDefaultMessage')
            );
        }
        if (props.reloadPatient) {
            await props.reloadPatient();
        }
        await props.onSave(requestId);
    }
}

export function ggzoIntV1RequestInitializeCustomControlData() {
    return {
        heeftNameting: false,
        nameting: null,
        emailadres: null,
        nametingOp: null,
    };
}
